module.exports = __webpack_public_path__ + "img/car-what-is.5de84fb.webp";